import { Stack, Typography } from '@mui/material';

import { VerticalScoreBar } from '@/ui/components/score-bars/VerticalScoreBar';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';
import { ScoreColor } from '@/ui/utils/get-color-for-score';

export function ScoreBars({
  value,
  refValue,
  colors,
}: {
  value: number;
  refValue: number;
  colors: ScoreColor;
}) {
  return (
    <Stack spacing={3} direction={'row'} alignItems={'end'} paddingTop={3}>
      <Stack
        direction={'column'}
        alignItems={'center'}
        justifyContent={'end'}
        height={'100%'}
      >
        <VerticalScoreBar
          value={value}
          colors={colors}
          position={
            value === refValue
              ? 'normal'
              : value > refValue
                ? 'higher'
                : 'lower'
          }
        />
        <Typography sx={{ fontSize: '1rem', mt: 1, fontWeight: '700' }}>
          {translate('Projects.teCO2')}
        </Typography>
      </Stack>
      <Stack
        direction={'column'}
        alignItems={'center'}
        height={'100%'}
        justifyContent={'end'}
      >
        <VerticalScoreBar
          value={refValue}
          colors={{
            main: ColorsRaw.scores.Anthracite_4,
            secondary: ColorsRaw.scores.Antracite_4012,
            text: ColorsRaw.basic.Cream,
          }}
          position="normal"
        />
        <Typography sx={{ fontSize: '1rem', mt: 1, fontWeight: '700' }}>
          {translate('Projects.ref-value')}
        </Typography>
      </Stack>
    </Stack>
  );
}
